<eo-base-form-control
  [styleClass]="getStyleClass()"
  [label]="getLabel()"
  [help]="getHelp()"
  [errors]="getErrors()"
  [notApplicableLabel]="notApplicableLabel"
  [canBeNotApplicable]="canBeNotApplicable"
  [notApplicable]="notApplicable"
  (onRemove)="onRemoveHandler()"
  (onChange)="onChangeHandler($event)"
  (onBlur)="onBlurHandler($event)"
  (onFocus)="onFocusHandler($event)"
>
  <div class="border-1 border-solid border-gray-300 border-round-md">
    <div class="flex justify-content-end align-items-center gap-2 m-2">
      <p-button
        size="small"
        outlined
        [label]="config?.addButtonLabel"
        [icon]="config?.addButtonIcon"
        [styleClass]="config?.addButtonStyleClass"
        (onClick)="onAddNew()"
      />
      <p-button
        *ngIf="this.config?.control?.value?.length > 0"
        size="small"
        outlined
        [label]="config?.clearButtonLabel"
        [icon]="config?.clearButtonIcon"
        [styleClass]="config?.clearButtonStyleClass"
        (onClick)="onClear()"
      />
    </div>

    @if(config?.tableProperties?.length != 0 &&
    this.config?.control?.value?.length > 0) {
    <p-table
      [value]="this.config?.control?.value ?? []"
      styleClass="p-datatable-sm p-datatable-striped"
      [tableStyle]="{ 'min-width': '50rem' }"
    >
      <ng-template pTemplate="header">
        <tr class="th-bg-gray-50 th-font-semibold">
          <th *ngFor="let prop of config!.tableProperties">
            {{ prop.label }}
          </th>
          <th></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-item>
        <tr>
          <td *ngFor="let prop of config!.tableProperties">
            {{ getValue(item, prop) }}
          </td>
          <td>
            <div class="flex gap-2 justify-content-end align-items-center">
              <p-button
                text
                [icon]="config?.deleteButtonIcon"
                [styleClass]="config?.deleteButtonStyleClass"
                (onClick)="onDelete(item)"
              />
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
    }
  </div>
</eo-base-form-control>

<p-dialog
  #dialog
  [focusOnShow]="false"
  [header]="config?.formHeader ?? 'Προσθήκη Νέου'"
  [modal]="true"
  [(visible)]="formDialogVisible"
  [style]="{ minWidth: '50vw', maxWidth: '90vw' }"
>
  <eo-table-field-form #tableFieldForm [config]="formConfig!" />

  <div class="w-full flex justify-content-end">
    <p-button
      [label]="config?.submitButtonLabel"
      [disabled]="!tableFieldForm.valid"
      (onClick)="onDialogSubmit()"
    />
  </div>
</p-dialog>
